import { motion } from 'framer-motion'
import { Helmet } from 'react-helmet-async'

const Terms = () => {
    return (
        <>
            <Helmet>
                <title>Terms of Service | Margdarshak</title>
                <meta name="description" content="Read Margdarshak's terms of service to understand the rules and guidelines for using our platform." />
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <div className="min-h-screen bg-gray-50 pt-20">
                {/* Hero Section */}
                <section className="bg-gradient-to-br from-primary-600 via-secondary-600 to-primary-800 text-white py-16 relative overflow-hidden">
                    {/* Background Pattern */}
                    <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')] opacity-20"></div>

                    <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6 }}
                            className="text-center"
                        >
                            <div className="inline-flex items-center justify-center w-20 h-20 bg-accent-100/20 backdrop-blur-sm rounded-full mb-8">
                                <svg className="w-10 h-10 text-accent-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                            </div>

                            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 text-white drop-shadow-lg">
                                Terms of <span className="text-accent-400">Service</span>
                            </h1>
                            <p className="text-xl sm:text-2xl mb-8 max-w-3xl mx-auto text-white drop-shadow-md">
                                Please read these terms carefully before using our services.
                            </p>
                        </motion.div>
                    </div>
                </section>

                {/* Content Section */}
                <section className="py-16">
                    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6 }}
                            className="card p-8"
                        >
                            <div className="prose prose-lg max-w-none">
                                <p className="text-sm text-gray-500 mb-8">
                                    Last updated: {new Date().toLocaleDateString()}
                                </p>

                                <h2>1. Acceptance of Terms</h2>
                                <p>
                                    By accessing and using Margdarshak's services, you accept and agree to be bound by
                                    the terms and provision of this agreement.
                                </p>

                                <h2>2. Description of Service</h2>
                                <p>
                                    Margdarshak provides education guidance services, including but not limited to:
                                </p>
                                <ul>
                                    <li>Course and university information</li>
                                    <li>Admission guidance and counseling</li>
                                    <li>Career planning and advice</li>
                                    <li>Educational resource access</li>
                                </ul>

                                <h2>3. User Responsibilities</h2>
                                <p>As a user of our services, you agree to:</p>
                                <ul>
                                    <li>Provide accurate and complete information</li>
                                    <li>Use the service for lawful purposes only</li>
                                    <li>Respect the rights of other users</li>
                                    <li>Not engage in any harmful or disruptive activities</li>
                                </ul>

                                <h2>4. Privacy and Data Protection</h2>
                                <p>
                                    Your privacy is important to us. Please review our Privacy Policy, which also governs
                                    your use of the service, to understand our practices.
                                </p>

                                <h2>5. Intellectual Property</h2>
                                <p>
                                    All content, trademarks, and intellectual property on this platform are owned by
                                    Margdarshak or our licensors. You may not use, reproduce, or distribute any content
                                    without explicit permission.
                                </p>

                                <h2>6. Disclaimers</h2>
                                <p>
                                    The information provided on this platform is for general guidance purposes only.
                                    We do not guarantee the accuracy, completeness, or suitability of any information
                                    for your specific circumstances.
                                </p>

                                <h2>7. Limitation of Liability</h2>
                                <p>
                                    Margdarshak shall not be liable for any indirect, incidental, special, or consequential
                                    damages arising from your use of our services.
                                </p>

                                <h2>8. Indemnification</h2>
                                <p>
                                    You agree to indemnify and hold harmless Margdarshak from any claims, damages, or
                                    expenses arising from your use of our services or violation of these terms.
                                </p>

                                <h2>9. Termination</h2>
                                <p>
                                    We reserve the right to terminate or suspend your access to our services at any time,
                                    without notice, for conduct that we believe violates these terms or is harmful to
                                    other users or our business.
                                </p>

                                <h2>10. Governing Law</h2>
                                <p>
                                    These terms shall be governed by and construed in accordance with the laws of India,
                                    without regard to its conflict of law provisions.
                                </p>

                                <h2>11. Changes to Terms</h2>
                                <p>
                                    We reserve the right to modify these terms at any time. Changes will be effective
                                    immediately upon posting on this page.
                                </p>

                                <h2>12. Contact Information</h2>
                                <p>
                                    If you have any questions about these terms, please contact us at:
                                </p>
                                <ul>
                                    <li>Email: legal@margdarshak.com</li>
                                    <li>Phone: +91-9810530354</li>
                                    <li>Address: Lal Kuah, Ghaziabad, Uttar Pradesh, India</li>
                                </ul>
                            </div>
                        </motion.div>
                    </div>
                </section>
            </div>
        </>
    )
}

export default Terms
